import React, { useState, useEffect } from 'react'
import Player from '../player';
import Map from '../map'
import API from "../../utils/API";
import { useHistory, useParams } from 'react-router-dom';
import MusicBtn from "../../components/SoundBtns/MusicBtn"
import { CastleGuardMoved } from '../../data/maps/1'
import store from '../../config/store'
import { resolveStageEntrySpawn, prepareConnectedTransition } from '../../config/worldTransitions';

//creates a game map for the castle map after the guard moves
function CastleWorldGuardMoved(props) {
    let tiles = CastleGuardMoved;
   
    const { id } = useParams();
  const history = useHistory();
    store.dispatch({
        type: 'ADD_TILES', payload: {
            tiles,
        }
    });
    const [userAvatar, setUserAvatar] = useState(null)
    
    useEffect(() => {
        API.UpdateSpritePlace("castle", id).then(()=> {
        })
        // API.getUserSprite(id).then(user => {
        //     const { sprite } = user.data[0].sprite[0]
        //     return setUserAvatar(sprite)
        // })
        const getUserData = async () => {
            const userData = await API.getUser(id);
            const user = await userData.json();
            const { sprite, name, apiFirstThiefTalk } = user.sprite[0];
      
            setUserAvatar(sprite);
         
          };
      
          getUserData();
    }, []);


    // Keep the connected entrance stable across avatar/API-driven rerenders.
    const [initialPosition] = useState(() => resolveStageEntrySpawn(id, "castle", props.initialPosition));

    return (
        <div
            id="world-container"
            style={{
                position: 'relative',
                width: '968px',
                top: '35%',
                // marginTop: '50px',
                marginLeft: '3px',
                border: '4px solid black',
                borderRadius: '5px'
            }}
        >
            <MusicBtn />
            <Map />
            <Player
                avatar={props.avatar}
                avatarName={props.avatarName}
                onRightEdge={(position) => {
                    const cell = [position[0] / 64, position[1] / 64];
                    const transition = prepareConnectedTransition(id, "castle", "EAST", cell);
                    if (!transition) return;
                    API.UpdateSpritePlace(transition.destination, id).catch(() => {});
                    history.push(`/${transition.destination}/` + id);
                }}
                exitZones={{ EAST: [[14, 8], [14, 9], [14, 10]] }}
                initialPosition={initialPosition}
            />
        </div>
    )
}

export default CastleWorldGuardMoved;